export enum IconTextContentMode {
  Bottom = 'bottom',
  Right = 'right',
}
